import {ENViewType} from '../../enums';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetView implements QueryProtocol {

  constructor(
    public uid: string = null,
    public identifier: string = null,
    public type: ENViewType[] = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetView(
      'uid' in params ? params.uid : null,
      'identifier' in params ? params.identifier : null,
      'type' in params ? params.type : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
